export default "/js/50a6cd509ab1a89a5956d6a8fbc7f377.ttf";